import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/order-management', search: { page: 1, limit: undefined, search: undefined, status: undefined, tab: undefined, view: undefined } });
  },
  component: () => null,
});
